<template>
  <v-data-table :headers="headers" :items="GetCourseList" item-key="Course_Category_Name" class="elevation-1" >
    <template v-slot:headers="props">
      <tr>
        <th v-for="header in props.headers" :key="header.text">
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <td class="text-xs-center">{{ props.item.Course_Category_Name }}</td>
        <td class="text-xs-center">
          <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCourseModal(props.item)">
              <v-icon>edit</v-icon>
          </v-btn>
          <v-btn color="error" icon class="btnAction" @click="RemoveCourseCategory(props.item)">
              <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "Course Category Name", value: "Course_Category_Name" },
        { text: "Actions" }
      ]
    };
  },
  computed: {
    GetCourseList() {
      return this.$store.getters.GetCourseList;
    }
  },
  methods: {
    OpenUpdateCourseModal(Item) {
      this.$emit("UpdateCourseCategory", Item);
    },
    RemoveCourseCategory(item) {
      if (confirm("Do you really want to delete?")) {
        let data = { "Course_Category_Id" : item['_id']}
        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/removecourse`,data )
            .then(response => {
              
              this.$store.commit("DeleteIndividualCourse", response["data"]["response"]);
              this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Deleted Course", Color: "green", Close: false });
            })
            .catch(err => {
              this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Deleting Course", Color: "red", Close: false});
            });
      }
    }},
    mounted() {

      this.$http.get(`${this.$store.getters.GetProductionUrl}/course/getcourselist`)
        .then(response => {

          this.$store.commit("SetCourseList", response["data"]["response"]);
          return this.$http.get(`${this.$store.getters.GetProductionUrl}/category/getcategorylist`);
        })
        .then(response => {
          
            this.$store.commit("SetCategoryList", response["data"]["response"]);
        })
        .catch(err => {

          this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red", Close: false });
        });
    }
  
};
</script>
<style scoped>
    .btnAction{
        margin: 4px;
        border: 1px solid #d3d3d37a;
    }
</style>
